<template>
    <div class="upload-media-container">
        <div class="title-desc">
            <p class="title">Upload your media</p>
            <p class="desc">
                Venues want to see you and hear your music. Upload videos of you performing
                live, Band pics and music samples.
            </p>
        </div>
        <p class="counter">
            {{
                `${
                    userData.audios.length + userData.videos.length + userData.images.length
                } files uploaded`
            }}
        </p>
        <div class="upload-input">
            <input
                ref="uploader"
                type="file"
                @change="upload"
                accept="video/*,image/*,audio/mp3,audio/wav"
                multiple="multiple"
                hidden="hidden"
            />
            <button @click="triggerUpload" class="upload-btn">
                <img
                    src="/images/icons/media-upload-btn.svg"
                    class="upload-btn-icon"
                    alt="upload-media-btn"
                />
                <p class="upload-msg">Upload</p>
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'UploadMedia',
        props: {
            userData: {
                type: Object,
                required: true
            }
        },
        methods: {
            triggerUpload() {
                this.$refs.uploader.click()
            },
            upload(e) {
                if (!e.target.files.length) return

                Array.from(e.target.files).forEach((file) => {
                    const type = file['type'].split('/')[0]

                    switch (type) {
                        case 'video':
                            this.userData.videos.push(file)
                            break
                        case 'image':
                            this.userData.images.push(file)
                            break
                        case 'audio':
                            this.userData.audios.push(file)
                            break
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .upload-media-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 24px;

        .title-desc {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 8px;

            .title {
                color: #dedede;
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .desc {
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
            }
        }
        .counter {
            color: #dedede;
            @include base-font-16;
            font-weight: 400;
            line-height: 24px;
        }
        .upload-input {
            width: 100%;
            display: flex;
            justify-content: center;

            .upload-btn {
                max-width: 400px;
                width: 100%;
                height: 272px;
                border-radius: 8px;
                background: rgba(255, 255, 255, 0);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border: 1px solid #acacac;
                background: rgba(255, 255, 255, 0);

                .upload-btn-icon {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                }
                .upload-msg {
                    color: #646464;
                    text-align: center;
                    @include base-font-16;
                    line-height: 125%;
                }
            }
        }
    }
</style>
